import { dataFlowFunctionDescriptions } from 'Resources/StringResources/Src/DataFlowFunctionDescriptions';

// AUTOMATICALLY GENERATED BY ADF MAPPING DATA FLOW EXECUTOR
/* eslint-disable */
export const functionsDescriptionMap: any =
{
  "toInteger" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toInteger,
    "returnType" : "integer",
    "examples" : [ "toInteger(123)", "123", "toInteger('123')", "123", "toInteger('$123', '$###')", "123" ],
    "parametersDescription" : [ "value", "format", "locale" ],
    "parametersToAutoComplete" : [ "value", "format", "locale" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "toDecimal" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toDecimal,
    "returnType" : "decimal(10,0)",
    "examples" : [ "toDecimal(123.45)", "123.45", "toDecimal('123.45', 8, 4)", "123.4500", "toDecimal('$123.45', 8, 4,'$###.00')", "123.4500", "toDecimal('€123,45', 10, 2, '€###,##', 'de')", "123.45" ],
    "parametersDescription" : [ "value", "precision", "scale", "format", "locale" ],
    "parametersToAutoComplete" : [ "value", "precision", "scale", "format", "locale" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "integral", "integral", "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "equalsIgnoreCase" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_equalsIgnoreCase,
    "returnType" : "boolean",
    "examples" : [ "'abc'<=>'Abc'", "true", "equalsIgnoreCase('abc', 'Abc')", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "dayOfYear" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_dayOfYear,
    "returnType" : "integer",
    "examples" : [ "dayOfYear(toDate('2016-04-09'))", "100" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "datetime" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "sha1" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_sha1,
    "returnType" : "string",
    "examples" : [ "sha1(5, 'gunchus', 8.2, 'bojjus', true, toDate('2010-4-4'))", "'46d3b478e8ec4e1f3b453ac3d8e59d5854e282bb'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "sha1Binary" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_sha1Binary,
    "returnType" : "binary",
    "examples" : [ "sha1(5, 'gunchus', 8.2, 'bojjus', true, toDate('2010-4-4'))", "unHex('46d3b478e8ec4e1f3b453ac3d8e59d5854e282bb')" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "maxIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_maxIf,
    "returnType" : "any",
    "examples" : [ "maxIf(region == 'West', sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "any" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "false" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_false,
    "returnType" : "boolean",
    "examples" : [ "(10 + 20 > 30)", "false", "(10 + 20 > 30)", "false()" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "initCap" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_initCap,
    "returnType" : "string",
    "examples" : [ "initCap('cool iceCREAM')", "'Cool Icecream'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "flatten" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_flatten,
    "returnType" : "array",
    "examples" : [ "flatten([['bojjus', 'girl'], ['gunchus', 'boy']])", "['bojjus', 'girl', 'gunchus', 'boy']", "flatten(['bojjus', 'gunchus'])", "['bojjus', 'gunchus']", "flatten([[['bojjus', 'gunchus']]])", "[['bojjus', 'gunchus']]", "flatten([[['bojjus', 'gunchus']]] , true)", "['bojjus', 'gunchus']" ],
    "parametersDescription" : [ "array of array of items", "recurse" ],
    "parametersToAutoComplete" : [ "array_of_array_of_items", "recurse" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "boolean" ],
    "requiredParameters" : 1
  },
  "lesserOrEqual" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_lesserOrEqual,
    "returnType" : "boolean",
    "examples" : [ "lesserOrEqual(12, 12)", "true", "('dumbo' <= 'dum')", "false" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "lead" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_lead,
    "returnType" : "any",
    "examples" : [ "lead(amount, 2)", "", "lead(amount, 2000, 100)", "" ],
    "parametersDescription" : [ "value", "number of rows to look after", "default value" ],
    "parametersToAutoComplete" : [ "value", "number_of_rows_to_look_after", "default_value" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "number", "any" ],
    "requiredParameters" : 1,
    "functionType" : "Window"
  },
  "coalesce" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_coalesce,
    "returnType" : "any",
    "examples" : [ "coalesce(10, 20)", "10", "coalesce(toString(null), toString(null), 'dumbo', 'bo', 'go')", "'dumbo'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "count" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_count,
    "returnType" : "long",
    "examples" : [ "count(custId)", "", "count(custId, custName)", "", "count()", "", "count(iif(isNull(custId), 1, NULL))", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 0,
    "functionType" : "Aggregate"
  },
  "in" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_in,
    "returnType" : "boolean",
    "examples" : [ "in([10, 20, 30], 10)", "true", "in(['good', 'kid'], 'bad')", "false" ],
    "parametersDescription" : [ "array of items", "item to find" ],
    "parametersToAutoComplete" : [ "array_of_items", "item_to_find" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "currentTimestamp" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_currentTimestamp,
    "returnType" : "timestamp",
    "examples" : [ "currentTimestamp() == toTimestamp('2250-12-31 12:12:12')", "false" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "ltrim" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_ltrim,
    "returnType" : "string",
    "examples" : [ "ltrim('  dumbo  ')", "'dumbo  '", "ltrim('!--!du!mbo!', '-!')", "'du!mbo!'" ],
    "parametersDescription" : [ "string to trim", "trim characters" ],
    "parametersToAutoComplete" : [ "string_to_trim", "trim_characters" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "factorial" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_factorial,
    "returnType" : "long",
    "examples" : [ "factorial(5)", "120" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "countIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_countIf,
    "returnType" : "long",
    "examples" : [ "countIf(state == 'CA' && commission < 10000, name)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "any" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "rlike" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_rlike,
    "returnType" : "boolean",
    "examples" : [ "rlike('200.50', `(\\d+).(\\d+)`)", "true", "rlike('bogus', `M[0-9]+.*`)", "false" ],
    "parametersDescription" : [ "string", "pattern match" ],
    "parametersToAutoComplete" : [ "string", "pattern_match" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "soundex" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_soundex,
    "returnType" : "string",
    "examples" : [ "soundex('genius')", "'G520'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "concatWS" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_concatWS,
    "returnType" : "string",
    "examples" : [ "concatWS(' ', 'dataflow', 'is', 'awesome')", "'dataflow is awesome'", "isNull(concatWS(null, 'dataflow', 'is', 'awesome'))", "true", "concatWS(' is ', 'dataflow', 'awesome')", "'dataflow is awesome'" ],
    "parametersDescription" : [ "separator", "this", "that" ],
    "parametersToAutoComplete" : [ "separator", "this", "that" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string", "string" ],
    "requiredParameters" : 3,
    "functionType" : "General"
  },
  "isIgnore" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isIgnore,
    "returnType" : "boolean",
    "examples" : [ "isIgnore()", "", "isIgnore(1)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "sumDistinct" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_sumDistinct,
    "returnType" : "number",
    "examples" : [ "sumDistinct(col)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "replace" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_replace,
    "returnType" : "string",
    "examples" : [ "replace('doggie dog', 'dog', 'cat')", "'catgie cat'", "replace('doggie dog', 'dog', '')", "'gie '", "replace('doggie dog', 'dog')", "'gie '" ],
    "parametersDescription" : [ "string", "substring to find", "substring to replace" ],
    "parametersToAutoComplete" : [ "string", "substring_to_find", "substring_to_replace" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "dayOfWeek" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_dayOfWeek,
    "returnType" : "integer",
    "examples" : [ "dayOfWeek(toDate('2018-06-08'))", "6" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "datetime" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "crc32" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_crc32,
    "returnType" : "long",
    "examples" : [ "crc32(256, 'gunchus', 8.2, 'bojjus', true, toDate('2010-4-4'))", "3630253689L" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "blake2b" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_blake2b,
    "returnType" : "string",
    "examples" : [ "blake2b(256, 'gunchus', 8.2, 'bojjus', true, toDate('2010-4-4'))", "'c9521a5080d8da30dffb430c50ce253c345cc4c4effc315dab2162dac974711d'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer", "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "blake2bBinary" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_blake2bBinary,
    "returnType" : "binary",
    "examples" : [ "blake2b(256, 'gunchus', 8.2, 'bojjus', true, toDate('2010-4-4'))", "unHex('c9521a5080d8da30dffb430c50ce253c345cc4c4effc315dab2162dac974711d')" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer", "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isError" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isError,
    "returnType" : "boolean",
    "examples" : [ "isError()", "", "isError(1)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "hasError" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_hasError,
    "returnType" : "boolean",
    "examples" : [ "hasError('assert1')", "", "hasError('assert2')", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "assertErrorMessages" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_assertErrorMessages,
    "returnType" : "map",
    "examples" : [ "assertErrorMessages()", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "rtrim" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_rtrim,
    "returnType" : "string",
    "examples" : [ "rtrim('  dumbo  ')", "'  dumbo'", "rtrim('!--!du!mbo!', '-!')", "'!--!du!mbo'" ],
    "parametersDescription" : [ "string to trim", "trim characters" ],
    "parametersToAutoComplete" : [ "string_to_trim", "trim_characters" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "minus" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_minus,
    "returnType" : "any",
    "examples" : [ "minus(20, 10)", "10", "20 - 10", "10", "minus(toDate('2012-12-15'), 3)", "toDate('2012-12-12')", "toDate('2012-12-15') - 3", "toDate('2012-12-12')", "toTimestamp('2019-02-03 05:19:28.871', 'yyyy-MM-dd HH:mm:ss.SSS') + (days(1) + hours(2) - seconds(10))", "toTimestamp('2019-02-04 07:19:18.871', 'yyyy-MM-dd HH:mm:ss.SSS')", "toTimestamp('2019-02-03 05:21:34.851', 'yyyy-MM-dd HH:mm:ss.SSS') - toTimestamp('2019-02-03 05:21:36.923', 'yyyy-MM-dd HH:mm:ss.SSS')", "-2072" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "sinh" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_sinh,
    "returnType" : "double",
    "examples" : [ "sinh(0)", "0.0" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isDelete" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isDelete,
    "returnType" : "boolean",
    "examples" : [ "isDelete()", "", "isDelete(1)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "union" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_union,
    "returnType" : "array",
    "examples" : [ "union([10, 20, 30], [20, 40])", "[10, 20, 30, 40]", "union(['bojjus', 'gunchus', 'bojjus'], ['gunchus'])", "['bojjus', 'gunchus']" ],
    "parametersDescription" : [ "first array", "second array" ],
    "parametersToAutoComplete" : [ "first_array", "second_array" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "array" ],
    "requiredParameters" : 2
  },
  "subMonths" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_subMonths,
    "returnType" : "datetime",
    "examples" : [ "subMonths(toDate('2016-09-30'), 1)", "toDate('2016-08-31')" ],
    "parametersDescription" : [ "date/timestamp", "months to subtract" ],
    "parametersToAutoComplete" : [ "date_or_timestamp", "months_to_subtract" ],
    "synonyms" : [ ],
    "inputTypes" : [ "datetime", "integral" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "intersect" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_intersect,
    "returnType" : "array",
    "examples" : [ "intersect([10, 20, 30], [20, 40])", "[20]", "intersect(['bojjus', 'gunchus', 'bojjus'], ['gunchus'])", "['gunchus']" ],
    "parametersDescription" : [ "first array", "second array" ],
    "parametersToAutoComplete" : [ "first_array", "second_array" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "array" ],
    "requiredParameters" : 2
  },
  "fromUTC" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_fromUTC,
    "returnType" : "timestamp",
    "examples" : [ "fromUTC(currentTimeStamp()) == toTimestamp('2050-12-12 19:18:12')", "false", "fromUTC(currentTimeStamp(), 'Asia/Seoul') != toTimestamp('2050-12-12 19:18:12')", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "timestamp", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "mod" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_mod,
    "returnType" : "any",
    "examples" : [ "mod(20, 8)", "4", "20 % 8", "4" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "toTimestamp" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toTimestamp,
    "returnType" : "timestamp",
    "examples" : [ "toTimestamp('2016-12-31 00:12:00')", "toTimestamp('2016-12-31 00:12:00')", "toTimestamp('2016-12-31T00:12:00', 'yyyy-MM-dd\\'T\\'HH:mm:ss', 'PST', 'en-US')", "toTimestamp('2016-12-31 00:12:00')", "toTimestamp('12/31/2016T00:12:00', 'MM/dd/yyyy\\'T\\'HH:mm:ss')", "toTimestamp('2016-12-31 00:12:00')", "millisecond(toTimestamp('2019-02-03 05:19:28.871', 'yyyy-MM-dd HH:mm:ss.SSS'))", "871" ],
    "parametersDescription" : [ "string", "timestamp format", "time zone", "locale" ],
    "parametersToAutoComplete" : [ "string", "timestamp_format", "time_zone", "locale" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "string", "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "levenshtein" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_levenshtein,
    "returnType" : "integer",
    "examples" : [ "levenshtein('boys', 'girls')", "4" ],
    "parametersDescription" : [ "from string", "to string" ],
    "parametersToAutoComplete" : [ "from_string", "to_string" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "variance" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_variance,
    "returnType" : "double",
    "examples" : [ "variance(sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "map" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_map,
    "returnType" : "any",
    "examples" : [ "map([1, 2, 3, 4], #item + 2)", "[3, 4, 5, 6]", "map(['a', 'b', 'c', 'd'], #item + '_processed')", "['a_processed', 'b_processed', 'c_processed', 'd_processed']" ],
    "parametersDescription" : [ "array", "map expression" ],
    "parametersToAutoComplete" : [ "array", "map_expression" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "unaryfunction" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "mapIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_mapIf,
    "returnType" : "any",
    "examples" : [ "mapIf([10, 20, 30], #item > 10, #item + 5)", "[25, 35]", "mapIf(['bojjus', 'gunchus', 'ammi'], length(#item) > 4, upper(#item))", "['BOJJUS', 'GUNCHUS']" ],
    "parametersDescription" : [ "array", "map expression", "map_expression" ],
    "parametersToAutoComplete" : [ "array", "map_expression", "map_expression" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "binaryfunction", "binaryfunction" ],
    "requiredParameters" : 3,
    "functionType" : "General"
  },
  "dropRight" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_dropRight,
    "returnType" : "string",
    "examples" : [ "dropRight('bojjus', 2)", "'bojj'", "dropRight('cake', 10)", "''" ],
    "parametersDescription" : [ "string to drop characters", "number of items to drop" ],
    "parametersToAutoComplete" : [ "string_to_drop_characters", "number_of_items_to_drop" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "integral" ],
    "requiredParameters" : 2
  },
  "mapIndex" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_mapIndex,
    "returnType" : "any",
    "examples" : [ "mapIndex([1, 2, 3, 4], #item + 2 + #index)", "[4, 6, 8, 10]" ],
    "parametersDescription" : [ "array", "map expression" ],
    "parametersToAutoComplete" : [ "array", "map_expression" ],
    "synonyms" : [ "iMap" ],
    "inputTypes" : [ "array", "binaryfunction" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "mapLoop" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_mapLoop,
    "returnType" : "any",
    "examples" : [ "mapLoop(3, #index * 10)", "[10, 20, 30]" ],
    "parametersDescription" : [ "integer", "map expression" ],
    "parametersToAutoComplete" : [ "integer", "map_expression" ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer", "unaryfunction" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "isNan" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isNan,
    "returnType" : "boolean",
    "examples" : [ "isNan(10.2)", "false" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1
  },
  "keys" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_keys,
    "returnType" : "array",
    "examples" : [ "keys(['bojjus' -> 'gunchus', 'appa' -> 'ammi'])", "['bojjus', 'appa']" ],
    "parametersDescription" : [ "map"],
    "parametersToAutoComplete" : [ "map" ],
    "synonyms" : [ ],
    "inputTypes" : [ "map" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "values" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_values,
    "returnType" : "array",
    "examples" : [ "values(['bojjus' -> 'gunchus', 'appa' -> 'ammi'])", "['gunchus', 'ammi']" ],
    "parametersDescription" : [ "map"],
    "parametersToAutoComplete" : [ "map" ],
    "synonyms" : [ ],
    "inputTypes" : [ "map" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "degrees" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_degrees,
    "returnType" : "double",
    "examples" : [ "degrees(3.141592653589793)", "180" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "equals" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_equals,
    "returnType" : "boolean",
    "examples" : [ "equals(12, 24)", "false", "12 == 24", "false", "'bad' == 'bad'", "true", "isNull('good' == toString(null))", "true", "isNull(null == null)", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "nTile" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_nTile,
    "returnType" : "integer",
    "examples" : [ "nTile()", "", "nTile(numOfBuckets)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 0,
    "functionType" : "Window"
  },
  "covarianceSampleIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_covarianceSampleIf,
    "returnType" : "double",
    "examples" : [ "covarianceSampleIf(region == 'West', sales, profit)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number", "number" ],
    "requiredParameters" : 3,
    "functionType" : "Aggregate"
  },
  "asin" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_asin,
    "returnType" : "double",
    "examples" : [ "asin(0)", "0.0" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isNull" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isNull,
    "returnType" : "boolean",
    "examples" : [ "isNull(NULL())", "true", "isNull('')", "false" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isBoolean" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isBoolean,
    "returnType" : "boolean",
    "examples" : [ "isBoolean('true')", "true", "isBoolean('no')", "true", "isBoolean('bojjus')", "false" ],
    "parametersDescription" : [ "string" ],
    "parametersToAutoComplete" : [ "string" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isShort" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isShort,
    "returnType" : "boolean",
    "examples" : [ "isShort('123')", "true", "isShort('$123', '$###')", "true", "isShort('gunchus')", "false" ],
    "parametersDescription" : [ "string", "format" ],
    "parametersToAutoComplete" : [ "string", "format" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isInteger" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isInteger,
    "returnType" : "boolean",
    "examples" : [ "isInteger('123')", "true", "isInteger('$123', '$###')", "true", "isInteger('gunchus')", "false" ],
    "parametersDescription" : [ "string", "format" ],
    "parametersToAutoComplete" : [ "string", "format" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isLong" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isLong,
    "returnType" : "boolean",
    "examples" : [ "isLong('123')", "true", "isLong('$123', '$###')", "true", "isLong('gunchus')", "false" ],
    "parametersDescription" : [ "string", "format" ],
    "parametersToAutoComplete" : [ "string", "format" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isFloat" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isFloat,
    "returnType" : "boolean",
    "examples" : [ "isFloat('123')", "true", "isFloat('$123.45', '$###.00')", "true", "isFloat('icecream')", "false" ],
    "parametersDescription" : [ "string", "format" ],
    "parametersToAutoComplete" : [ "string", "format" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isDouble" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isDouble,
    "returnType" : "boolean",
    "examples" : [ "isDouble('123')", "true", "isDouble('$123.45', '$###.00')", "true", "isDouble('icecream')", "false" ],
    "parametersDescription" : [ "string", "format" ],
    "parametersToAutoComplete" : [ "string", "format" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isByte" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isByte,
    "returnType" : "boolean",
    "examples" : [ "isByte('123')", "true", "isByte('chocolate')", "false" ],
    "parametersDescription" : [ "string", "format" ],
    "parametersToAutoComplete" : [ "string", "format" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isDecimal" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isDecimal,
    "returnType" : "boolean",
    "examples" : [ "isDecimal('123.45')", "true", "isDecimal('12/12/2000')", "false" ],
    "parametersDescription" : [ "string", "format" ],
    "parametersToAutoComplete" : [ "string", "format" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isDate" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isDate,
    "returnType" : "boolean",
    "examples" : [ "isDate('2012-8-18')", "true", "isDate('12/18--234234', 'MM/dd/yyyy')", "false" ],
    "parametersDescription" : [ "string", "format" ],
    "parametersToAutoComplete" : [ "string", "format" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isTimestamp" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isTimestamp,
    "returnType" : "boolean",
    "examples" : [ "isTimestamp('2016-12-31 00:12:00')", "true", "isTimestamp('2016-12-31T00:12:00', 'yyyy-MM-dd\\'T\\'HH:mm:ss', 'PST')", "true", "isTimestamp('2012-8222.18')", "false" ],
    "parametersDescription" : [ "string", "format" ],
    "parametersToAutoComplete" : [ "string", "format" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "expr" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_expr,
    "returnType" : "any",
    "examples" : [ "expr('price * discount')", "" ],
    "parametersDescription" : [ "literal expression" ],
    "parametersToAutoComplete" : [ "expression" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "radians" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_radians,
    "returnType" : "double",
    "examples" : [ "radians(180)", "3.141592653589793" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1
  },
  "bitwiseAnd" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_bitwiseAnd,
    "returnType" : "integral",
    "examples" : [ "bitwiseAnd(0xf4, 0xef)", "0xe4" ],
    "parametersDescription" : [ "integral", "integral" ],
    "parametersToAutoComplete" : [ "integral", "integral" ],
    "synonyms" : [ ],
    "inputTypes" : [ "integral", "integral" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "associate" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_associate,
    "returnType" : "map",
    "examples" : [ "associate('bojjus', 'gunchus', 'appa', 'ammi')", "['bojjus' -> 'gunchus', 'appa' -> 'ammi']", "associate('bojjus', 'gunchus')['bojjus']", "'gunchus'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 0
  },
  "bitwiseOr" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_bitwiseOr,
    "returnType" : "integral",
    "examples" : [ "bitwiseOr(0xf4, 0xef)", "0xff" ],
    "parametersDescription" : [ "integral", "integral" ],
    "parametersToAutoComplete" : [ "integral", "integral" ],
    "synonyms" : [ ],
    "inputTypes" : [ "integral", "integral" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "bitwiseXor" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_bitwiseXor,
    "returnType" : "any",
    "examples" : [ "bitwiseXor(0xf4, 0xef)", "0x1b", "bitwiseXor(true(), false())", "true", "bitwiseXor(true(), true())", "false" ],
    "parametersDescription" : [ "any", "any" ],
    "parametersToAutoComplete" : [ "any", "any" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "toBitSet" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toBitSet,
    "returnType" : "array",
    "examples" : [ "toBitSet([10, 32, 98])", "[4294968320L, 17179869184L]" ],
    "parametersDescription" : [ "any" ],
    "parametersToAutoComplete" : [ "any" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "isBitSet" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isBitSet,
    "returnType" : "boolean",
    "examples" : [ "isBitSet(toBitSet([10, 32, 98]), 10)", "true" ],
    "parametersDescription" : [ "bitset", "bit to check" ],
    "parametersToAutoComplete" : [ "array", "integer" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "integer" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "setBitSet" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_setBitSet,
    "returnType" : "array",
    "examples" : [ "setBitSet(toBitSet([10, 32]), [98])", "[4294968320L, 17179869184L]" ],
    "parametersDescription" : [ "bitset", "bit ordinals to set" ],
    "parametersToAutoComplete" : [ "array", "array" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "array" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "between" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_between,
    "returnType" : "boolean",
    "examples" : [ "between(10, 5, 24)", "true", "between(currentDate(), currentDate() + 10, currentDate() + 20)", "false"],
    "parametersDescription" : [ "valueToCheck", "leftBound", "rightBound" ],
    "parametersToAutoComplete" : [ "valueToCheck", "leftBound", "rightBound" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any", "any" ],
    "requiredParameters" : 3,
    "functionType" : "General"
  },
  "isDistinct" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isDistinct,
    "returnType" : "boolean",
    "examples" : [ "isDistinct(custId, custName)", ""],
    "parametersDescription" : [ "any", "any" ],
    "parametersToAutoComplete" : [ "any", "any" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "sumDistinctIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_sumDistinctIf,
    "returnType" : "number",
    "examples" : [ "sumDistinctIf(state == 'CA' && commission < 10000, sales)", "", "sumDistinctIf(true, sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "weeks" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_weeks,
    "returnType" : "long",
    "examples" : [ "weeks(2)", "1209600000L" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "startsWith" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_startsWith,
    "returnType" : "boolean",
    "examples" : [ "startsWith('dumbo', 'du')", "true" ],
    "parametersDescription" : [ "string", "substring to check" ],
    "parametersToAutoComplete" : [ "string", "substring_to_check" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "normalize" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_normalize,
    "returnType" : "string",
    "examples" : [ "regexReplace(normalize('bo²s'), `\\p{M}`, '')", "'boys'" ],
    "parametersDescription" : [ "String to normalize" ],
    "parametersToAutoComplete" : [ "String_to_normalize" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "doubleToSingleCharacterSet" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_doubleToSingleCharacterSet,
    "returnType" : "string",
    "examples" : [ `doubleToSingleCharacterSet('Ｈｅｌｌｏ，　ｗｏｒｌｄ！')`, `Hello, world!`, `doubleToSingleCharacterSet('Ｈｅｌｌｏ，　ｗｏｒｌｄ！abcd')`, `Hello, world!abcd`],
    "parametersDescription" : [ "String to normalize" ],
    "parametersToAutoComplete" : [ "String_to_normalize" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "decode" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_decode,
    "returnType" : "string",
    "examples" : [ `decode(array(toByte(97),toByte(98),toByte(99)), 'US-ASCII')`, `abc`],
    "parametersDescription" : [ "Input data", "Charset" ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "encode" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_encode,
    "returnType" : "binary",
    "examples" : [ `encode('abc', 'US-ASCII')`, `array(toByte(97),toByte(98),toByte(99))`],
    "parametersDescription" : [ "Input string", "Charset" ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "char" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_char,
    "returnType" : "string",
    "examples" : [ `char(65)`, `'A'`, `char(97)`, `'a'`],
    "parametersDescription" : [ "Input number" ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer"],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "ascii" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_ascii,
    "returnType" : "integer",
    "examples" : [ `ascii('A')`, `65`, `ascii('a')`, `97`],
    "parametersDescription" : [ "Input character" ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string"],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "escape" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_escape,
    "returnType" : "string",
    "examples" : [ "escape('{\\\"value\\\": 10}', 'json')", "'{\\\\\"value\\\\\": 10}'" ],
    "parametersDescription" : [ "string to escape", "format" ],
    "parametersToAutoComplete" : [ "string_to_escape", "format" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "unescape" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_unescape,
    "returnType" : "string",
    "examples" : [ "unescape('{\\\\\"value\\\\\": 10}', 'json')", "'{\\\"value\\\": 10}'" ],
    "parametersDescription" : [ "string to unescape", "format" ],
    "parametersToAutoComplete" : [ "string_to_unescape", "format" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "iif" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_iif,
    "returnType" : "any",
    "examples" : [ "iif(10 + 20 == 30, 'dumbo', 'gumbo')", "'dumbo'", "iif(10 > 30, 'dumbo', 'gumbo')", "'gumbo'", "iif(month(toDate('2018-12-01')) == 12, 345.12, 102.67)", "345.12" ],
    "parametersDescription" : [ "condition", "true_expression", "false_expression" ],
    "parametersToAutoComplete" : [ "condition", "true_expression", "false_expression" ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "covarianceSample" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_covarianceSample,
    "returnType" : "double",
    "examples" : [ "covarianceSample(sales, profit)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "minute" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_minute,
    "returnType" : "integer",
    "examples" : [ "minute(toTimestamp('2009-07-30 12:58:59'))", "58", "minute(toTimestamp('2009-07-30 12:58:59'), 'PST')", "58" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "timestamp", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "minIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_minIf,
    "returnType" : "any",
    "examples" : [ "minIf(region == 'West', sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "any" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "uuid" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_uuid,
    "returnType" : "string",
    "examples" : [ "uuid()", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "toBinary" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toBinary,
    "returnType" : "binary",
    "examples" : [ "toBinary(3)", "[0x11]" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "hex": {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_hex,
    "returnType" : "string",
    "examples" : [ "hex(toBinary([toByte(0x1f), toByte(0xad), toByte(0xbe)]))", "'1fadbe'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "binary" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "unhex": {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_unhex,
    "returnType" : "binary",
    "examples" : [ "unhex('1fadbe')", "toBinary([toByte(0x1f), toByte(0xad), toByte(0xbe)])", "unhex(md5(5, 'gunchus', 8.2, 'bojjus', true, toDate('2010-4-4')))", "toBinary([toByte(0x4c), toByte(0xe8), toByte(0xa8), toByte(0x80), toByte(0xbd), toByte(0x62), toByte(0x1a), toByte(0x1f), toByte(0xfa), toByte(0xd0), toByte(0xbc), toByte(0xa9), toByte(0x05), toByte(0xe1), toByte(0xbc), toByte(0x5a)])'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "columns" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_columns,
    "returnType" : "any",
    "examples" : [ "columns()", "", "columns('DeriveStream')", "" ],
    "parametersDescription" : [ "stream name" ],
    "parametersToAutoComplete" : [ "stream_name" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "columnNames" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_columnNames,
    "returnType" : "string[]",
    "examples" : [ "columnNames()", "", "columnNames('DeriveStream')", "", "columnNames('DeriveStream', true())", "", "columnNames('', true())", "", "columnNames(toString(null()), true())", "" ],
    "parametersDescription" : [ "stream name", "flag to get drifted columns only" ],
    "parametersToAutoComplete" : [ "stream_name", "get_drifted_only" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "boolean"],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "hasColumn" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_hasColumn,
    "returnType" : "boolean",
    "examples" : [ "hasColumn('parent')", "" ],
    "parametersDescription" : [ "column name", "stream name" ],
    "parametersToAutoComplete" : [ "column_name", "stream_name" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "dayOfMonth" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_dayOfMonth,
    "returnType" : "integer",
    "examples" : [ "dayOfMonth(toDate('2018-06-08'))", "8" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "datetime" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "kurtosis" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_kurtosis,
    "returnType" : "double",
    "examples" : [ "kurtosis(sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "monthsBetween" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_monthsBetween,
    "returnType" : "double",
    "examples" : [ "monthsBetween(toTimestamp('1997-02-28 10:30:00'), toDate('1996-10-30'))", "3.94959677" ],
    "parametersDescription" : [ "from date/timestamp", "to date/timestamp", "roundoff", "time zone" ],
    "parametersToAutoComplete" : [ "from_date_or_timestamp", "to_date_or_timestamp", "roundoff", "time_zone" ],
    "synonyms" : [ ],
    "inputTypes" : [ "datetime", "datetime", "boolean", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "lag" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_lag,
    "returnType" : "any",
    "examples" : [ "lag(amount, 2)", "", "lag(amount, 2000, 100)", "" ],
    "parametersDescription" : [ "value", "number of rows to look before", "default value" ],
    "parametersToAutoComplete" : [ "value", "number_of_rows_to_look_before", "default_value" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "number", "any" ],
    "requiredParameters" : 1,
    "functionType" : "Window"
  },
  "sha2" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_sha2,
    "returnType" : "string",
    "examples" : [ "sha2(256, 'gunchus', 8.2, 'bojjus', true, toDate('2010-4-4'))", "'afe8a553b1761c67d76f8c31ceef7f71b66a1ee6f4e6d3b5478bf68b47d06bd3'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "sha2Binary" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_sha2Binary,
    "returnType" : "binary",
    "examples" : [ "sha2(256, 'gunchus', 8.2, 'bojjus', true, toDate('2010-4-4'))", "unHex('afe8a553b1761c67d76f8c31ceef7f71b66a1ee6f4e6d3b5478bf68b47d06bd3')" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "rank" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_rank,
    "returnType" : "integer",
    "examples" : [ "rank()", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "Window"
  },
  "seconds" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_seconds,
    "returnType" : "long",
    "examples" : [ "seconds(2)", "2000L" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "left" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_left,
    "returnType" : "string",
    "examples" : [ "left('bojjus', 2)", "'bo'", "left('bojjus', 20)", "'bojjus'" ],
    "parametersDescription" : [ "string to subset", "number of characters" ],
    "parametersToAutoComplete" : [ "string_to_subset", "number_of_characters" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "integral" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "varianceSampleIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_varianceSampleIf,
    "returnType" : "double",
    "examples" : [ "varianceSampleIf(region == 'West', sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "log10" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_log10,
    "returnType" : "double",
    "examples" : [ "log10(100)", "2" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "avg" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_avg,
    "returnType" : "number",
    "examples" : [ "avg(sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "rowNumber" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_rowNumber,
    "returnType" : "integer",
    "examples" : [ "rowNumber()", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "Window"
  },
  "concat" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_concat,
    "returnType" : "string",
    "examples" : [ "concat('dataflow', 'is', 'awesome')", "'dataflowisawesome'", "'dataflow' + 'is' + 'awesome'", "'dataflowisawesome'", "isNull('sql' + null)", "true" ],
    "parametersDescription" : [ "this", "that" ],
    "parametersToAutoComplete" : [ "this", "that" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "pMod" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_pMod,
    "returnType" : "any",
    "examples" : [ "pmod(-20, 8)", "4" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "mean" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_mean,
    "returnType" : "number",
    "examples" : [ "mean(sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "isUpsert" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isUpsert,
    "returnType" : "boolean",
    "examples" : [ "isUpsert()", "", "isUpsert(1)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "fromBase64" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_fromBase64,
    "returnType" : "string",
    "examples" : [ "fromBase64('Z3VuY2h1cw==')", "'gunchus'", "fromBase64('SGVsbG8gV29ybGQ=', 'Windows-1252')", "'Hello World'"],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "min" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_min,
    "returnType" : "any",
    "examples" : [ "min(sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "unfold" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_unfold,
    "returnType" : "any",
    "examples" : [ "unfold(addresses)", "", "unfold( @(name = salesPerson, sales = salesAmount) )", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "array" ],
    "requiredParameters" : 1
  },
  "instr" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_instr,
    "returnType" : "integer",
    "examples" : [ "instr('dumbo', 'mbo')", "3", "instr('microsoft', 'o')", "5", "instr('good', 'bad')", "0" ],
    "parametersDescription" : [ "string", "substring to find" ],
    "parametersToAutoComplete" : [ "string", "substring_to_find" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "year" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_year,
    "returnType" : "integer",
    "examples" : [ "year(toDate('2012-8-8'))", "2012" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "datetime" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "lower" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_lower,
    "returnType" : "string",
    "examples" : [ "lower('GunChus')", "'gunchus'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "currentUTC" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_currentUTC,
    "returnType" : "timestamp",
    "examples" : [ "currentUTC() == toTimestamp('2050-12-12 19:18:12')", "false", "currentUTC() != toTimestamp('2050-12-12 19:18:12')", "true", "fromUTC(currentUTC(), 'Asia/Seoul') != toTimestamp('2050-12-12 19:18:12')", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "divide" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_divide,
    "returnType" : "any",
    "examples" : [ "divide(20, 10)", "2", "20 / 10", "2" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "or" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_or,
    "returnType" : "boolean",
    "examples" : [ "or(true, false)", "true", "true || false", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "boolean" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "stddevPopulation" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_stddevPopulation,
    "returnType" : "double",
    "examples" : [ "stddevPopulation(sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "cos" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_cos,
    "returnType" : "double",
    "examples" : [ "cos(10)", "-0.8390715290764524" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "null" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_null,
    "returnType" : "null",
    "examples" : [ "isNull('dumbo' + null)", "true", "isNull(10 * null)", "true", "isNull('')", "false", "isNull(10 + 20)", "false", "isNull(10/0)", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "upper" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_upper,
    "returnType" : "string",
    "examples" : [ "upper('bojjus')", "'BOJJUS'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "last" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_last,
    "returnType" : "any",
    "examples" : [ "last(sales)", "", "last(sales, false)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "boolean" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "toFloat" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toFloat,
    "returnType" : "float",
    "examples" : [ "toFloat(123.45)", "123.45f", "toFloat('123.45')", "123.45f", "toFloat('$123.45', '$###.00')", "123.45f" ],
    "parametersDescription" : [ "value", "format", "locale" ],
    "parametersToAutoComplete" : [ "value", "format", "locale" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "avgIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_avgIf,
    "returnType" : "number",
    "examples" : [ "avgIf(region == 'West', sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "addDays" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_addDays,
    "returnType" : "datetime",
    "examples" : [ "addDays(toDate('2016-08-08'), 1)", "toDate('2016-08-09')" ],
    "parametersDescription" : [ "date/timestamp", "days to add" ],
    "parametersToAutoComplete" : [ "date_or_timestamp", "days_to_add" ],
    "synonyms" : [ ],
    "inputTypes" : [ "datetime", "integral" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "notNull" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_notNull,
    "returnType" : "boolean",
    "examples" : [ "notNull(NULL())", "false", "notNull('')", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "cbrt" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_cbrt,
    "returnType" : "double",
    "examples" : [ "cbrt(8)", "2.0" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "hour" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_hour,
    "returnType" : "integer",
    "examples" : [ "hour(toTimestamp('2009-07-30 12:58:59'))", "12", "hour(toTimestamp('2009-07-30 12:58:59'), 'PST')", "12" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "timestamp", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "atan" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_atan,
    "returnType" : "double",
    "examples" : [ "atan(0)", "0.0" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "toLong" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toLong,
    "returnType" : "long",
    "examples" : [ "toLong(123)", "123", "toLong('123')", "123", "toLong('$123', '$###')", "123" ],
    "parametersDescription" : [ "value", "format", "locale" ],
    "parametersToAutoComplete" : [ "value", "format", "locale" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "partitionId" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_partitionId,
    "returnType" : "integer",
    "examples" : [ "partitionId()", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "dropLeft" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_dropLeft,
    "returnType" : "string",
    "examples" : [ "dropLeft('bojjus', 2)", "'jjus'", "dropLeft('cake', 10)", "''" ],
    "parametersDescription" : [ "string to drop characters", "number of items to drop" ],
    "parametersToAutoComplete" : [ "string_to_drop_characters", "number_of_items_to_drop" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "integral" ],
    "requiredParameters" : 2
  },
  "ceil" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_ceil,
    "returnType" : "number",
    "examples" : [ "ceil(-0.1)", "0" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "least" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_least,
    "returnType" : "any",
    "examples" : [ "least(10, 30, 15, 20)", "10", "least(toDate('2010-12-12'), toDate('2011-12-12'), toDate('2000-12-12'))", "toDate('2000-12-12')" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "subDays" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_subDays,
    "returnType" : "datetime",
    "examples" : [ "subDays(toDate('2016-08-08'), 1)", "toDate('2016-08-07')" ],
    "parametersDescription" : [ "date/timestamp", "days to subtract" ],
    "parametersToAutoComplete" : [ "date_or_timestamp", "days_to_subtract" ],
    "synonyms" : [ ],
    "inputTypes" : [ "datetime", "integral" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "stddevIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_stddevIf,
    "returnType" : "double",
    "examples" : [ "stddevIf(region == 'West', sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "isAssignable" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isAssignable,
    "returnType" : "boolean",
    "examples" : [ "isAssignable(byPosition(1), 'decimal')", "", "isAssignable(byName($colName), 'string')", "", "isAssignable(custName, 'name as (firstName as string, lastName as string)')", "", "isAssignable(byName($colName), 'string', true())", "" ],
    "parametersDescription" : [ "column/expression", "datatype", "exact match" ],
    "parametersToAutoComplete" : [ "column_or_expression", "datatype", "exact_match" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "string", "boolean" ],
    "requiredParameters" : 2
  },
  "reverse" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_reverse,
    "returnType" : "string",
    "examples" : [ "reverse('gunchus')", "'suhcnug'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "meanIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_meanIf,
    "returnType" : "number",
    "examples" : [ "meanIf(region == 'West', sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "filter" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_filter,
    "returnType" : "array",
    "examples" : [ "filter([1, 2, 3, 4], #item > 2)", "[3, 4]", "filter(['a', 'b', 'c', 'd'], #item == 'a' || #item == 'b')", "['a', 'b']" ],
    "parametersDescription" : [ "array", "filter expression" ],
    "parametersToAutoComplete" : [ "array", "filter_expression" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "unaryfunction" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "minutes" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_minutes,
    "returnType" : "long",
    "examples" : [ "minutes(2)", "120000L" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "regexSplit" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_regexSplit,
    "returnType" : "array",
    "examples" : [ "regexSplit('bojjusAgunchusBdumbo', `[CAB]`)", "['bojjus', 'gunchus', 'dumbo']", "regexSplit('bojjusAgunchusBdumboC', `[CAB]`)", "['bojjus', 'gunchus', 'dumbo', '']", "(regexSplit('bojjusAgunchusBdumboC', `[CAB]`)[1])", "'bojjus'", "isNull(regexSplit('bojjusAgunchusBdumboC', `[CAB]`)[20])", "true" ],
    "parametersDescription" : [ "string to split", "regex expression" ],
    "parametersToAutoComplete" : [ "string_to_split", "regex_expression" ],
    "synonyms" : [ "regex_split" ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "covariancePopulation" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_covariancePopulation,
    "returnType" : "double",
    "examples" : [ "covariancePopulation(sales, profit)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "nextSequence" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_nextSequence,
    "returnType" : "long",
    "examples" : [ "nextSequence() == 12313112", "false" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "mapAssociation" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_mapAssociation,
    "returnType" : "array",
    "examples" : [ "mapAssociation(['bojjus' -> 'gunchus', 'appa' -> 'ammi'], @(key = #key, value = #value))", "[@(key = 'bojjus', value = 'gunchus'), @(key = 'appa', value = 'ammi')]" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "map", "binaryfunction" ],
    "requiredParameters" : 2
  },
  "endsWith" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_endsWith,
    "returnType" : "boolean",
    "examples" : [ "endsWith('dumbo', 'mbo')", "true" ],
    "parametersDescription" : [ "string", "substring to check" ],
    "parametersToAutoComplete" : [ "string", "substring_to_check" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "millisecond" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_millisecond,
    "returnType" : "integer",
    "examples" : [ "millisecond(toTimestamp('2009-07-30 12:58:59.871', 'yyyy-MM-dd HH:mm:ss.SSS'))", "871" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "timestamp", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "hours" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_hours,
    "returnType" : "long",
    "examples" : [ "hours(2)", "7200000L" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "variancePopulationIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_variancePopulationIf,
    "returnType" : "double",
    "examples" : [ "variancePopulationIf(region == 'West', sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "second" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_second,
    "returnType" : "integer",
    "examples" : [ "second(toTimestamp('2009-07-30 12:58:59'))", "59" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "timestamp", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "at" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_at,
    "returnType" : "any",
    "examples" : [ "at(['bojjus', 'gunchus'], 1)", "'bojjus'", "['bojjus', 'gunchus'][1]", "'bojjus'", "isNull(['bojjus', 'gunchus'][0])", "true", "isNull(['bojjus', 'gunchus'][20])", "true", "at(['bojjus' -> 'gunchus', 'appa' -> 'ammi'], 'bojjus')", "'gunchus'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2
  },
  "toBoolean" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toBoolean,
    "returnType" : "boolean",
    "examples" : [ "toBoolean('true')", "true", "toBoolean('n')", "false", "isNull(toBoolean('truthy'))", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isMatch" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isMatch,
    "returnType" : "boolean",
    "examples" : [ "isMatch()", "", "isMatch(1)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "md5" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_md5,
    "returnType" : "string",
    "examples" : [ "md5(5, 'gunchus', 8.2, 'bojjus', true, toDate('2010-4-4'))", "'4ce8a880bd621a1ffad0bca905e1bc5a'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "md5Binary" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_md5Binary,
    "returnType" : "binary",
    "examples" : [ "md5(5, 'gunchus', 8.2, 'bojjus', true, toDate('2010-4-4'))", "unHex('4ce8a880bd621a1ffad0bca905e1bc5a')" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "max" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_max,
    "returnType" : "any",
    "examples" : [ "max(sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "variancePopulation" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_variancePopulation,
    "returnType" : "double",
    "examples" : [ "variancePopulation(sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "atan2" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_atan2,
    "returnType" : "double",
    "examples" : [ "atan2(0, 0)", "0.0" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number", "number" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "sqrt" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_sqrt,
    "returnType" : "double",
    "examples" : [ "sqrt(9)", "3" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "weekOfYear" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_weekOfYear,
    "returnType" : "integer",
    "examples" : [ "weekOfYear(toDate('2008-02-20'))", "8" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "datetime" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "iifNull" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_iifNull,
    "returnType" : "any",
    "examples" : [ "iifNull(10, 20)", "10", "iifNull(null, 20, 40)", "20", "iifNull('azure', 'data', 'factory')", "'azure'", "iifNull(null, 'data', 'factory')", "'data'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any", "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "greatest" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_greatest,
    "returnType" : "any",
    "examples" : [ "greatest(10, 30, 15, 20)", "30", "greatest(10, toInteger(null), 20)", "20", "greatest(toDate('2010-12-12'), toDate('2011-12-12'), toDate('2000-12-12'))", "toDate('2011-12-12')", "greatest(toTimestamp('2019-02-03 05:19:28.871', 'yyyy-MM-dd HH:mm:ss.SSS'), toTimestamp('2019-02-05 08:21:34.890', 'yyyy-MM-dd HH:mm:ss.SSS'))", "toTimestamp('2019-02-05 08:21:34.890', 'yyyy-MM-dd HH:mm:ss.SSS')" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "stddev" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_stddev,
    "returnType" : "double",
    "examples" : [ "stdDev(sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "floor" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_floor,
    "returnType" : "number",
    "examples" : [ "floor(-0.1)", "-1" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "negate" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_negate,
    "returnType" : "number",
    "examples" : [ "negate(13)", "-13" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "approxDistinctCount" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_approxDistinctCount,
    "returnType" : "long",
    "examples" : [ "approxDistinctCount(custId)", "", "approxDistinctCount(custId, custName)", ""],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "double" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "xor" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_xor,
    "returnType" : "boolean",
    "examples" : [ "xor(true, false)", "true", "xor(true, true)", "false", "true ^ false", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "boolean" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "split" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_split,
    "returnType" : "array",
    "examples" : [ "split('bojjus,guchus,dumbo', ',')", "['bojjus', 'guchus', 'dumbo']", "split('bojjus,guchus,dumbo', '|')", "['bojjus,guchus,dumbo']", "split('bojjus, guchus, dumbo', ', ')", "['bojjus', 'guchus', 'dumbo']", "split('bojjus, guchus, dumbo', ', ')[1]", "'bojjus'", "isNull(split('bojjus, guchus, dumbo', ', ')[0])", "true", "isNull(split('bojjus, guchus, dumbo', ', ')[20])", "true", "split('bojjusguchusdumbo', ',')", "['bojjusguchusdumbo']" ],
    "parametersDescription" : [ "string to split", "split characters" ],
    "parametersToAutoComplete" : [ "string_to_split", "split_characters" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "countDistinct" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_countDistinct,
    "returnType" : "long",
    "examples" : [ "countDistinct(custId, custName)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "distinct" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_distinct,
    "returnType" : "array",
    "examples" : [ "distinct([10, 20, 30, 10])", "[10, 20, 30]", "distinct(['bojjus', 'gunchus', 'bojjus'])", "['bojjus', 'gunchus']" ],
    "parametersDescription" : [ "array to make distinct" ],
    "parametersToAutoComplete" : [ "array_to_make_distinct" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array" ],
    "requiredParameters" : 1
  },
  "countAll" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_countAll,
    "returnType" : "long",
    "examples" : [ "countAll(custId, custName)", ""],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "countAllDistinct" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_countAllDistinct,
    "returnType" : "long",
    "examples" : [ "countAllDistinct(custId, custName)", ""],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "toUTC" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toUTC,
    "returnType" : "timestamp",
    "examples" : [ "toUTC(currentTimeStamp()) == toTimestamp('2050-12-12 19:18:12')", "false", "toUTC(currentTimeStamp(), 'Asia/Seoul') != toTimestamp('2050-12-12 19:18:12')", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "timestamp", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "slice" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_slice,
    "returnType" : "array",
    "examples" : [ "slice([10, 20, 30, 40], 1, 2)", "[10, 20]", "slice([10, 20, 30, 40], 2)", "[20, 30, 40]", "slice([10, 20, 30, 40], 2)[1]", "20", "isNull(slice([10, 20, 30, 40], 2)[0])", "true", "isNull(slice([10, 20, 30, 40], 2)[20])", "true", "slice(['a', 'b', 'c', 'd'], 8)", "[]" ],
    "parametersDescription" : [ "array to slice", "from 1-based index", "number of items" ],
    "parametersToAutoComplete" : [ "array_to_slice", "from_1-based_index", "number_of_items" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "integral", "integral" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "addMonths" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_addMonths,
    "returnType" : "datetime",
    "examples" : [ "addMonths(toDate('2016-08-31'), 1)", "toDate('2016-09-30')", "addMonths(toTimestamp('2016-09-30 10:10:10'), -1)", "toTimestamp('2016-08-31 10:10:10')" ],
    "parametersDescription" : [ "date/timestamp", "months to add" ],
    "parametersToAutoComplete" : [ "date_or_timestamp", "months_to_add" ],
    "synonyms" : [ ],
    "inputTypes" : [ "datetime", "integral", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "array" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_array,
    "returnType" : "array",
    "examples" : [ "array('bojjus', 'gunchus')", "['bojjus', 'gunchus']", "['bojjus', 'gunchus'][1]", "'bojjus'" ],
    "parametersDescription" : [ "items" ],
    "parametersToAutoComplete" : [ "items" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "toBase64" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toBase64,
    "returnType" : "string",
    "examples" : [ "toBase64('bojjus')", "'Ym9qanVz'", "toBase64('± 25000, € 5.000,- |', 'Windows-1252')", "'sSAyNTAwMCwggCA1LjAwMCwtIHw='" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "not" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_not,
    "returnType" : "boolean",
    "examples" : [ "not(true)", "false", "not(10 == 20)", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "reduce" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_reduce,
    "returnType" : "any",
    "examples" : [ "toString(reduce(['1', '2', '3', '4'], '0', #acc + #item, #result))", "'01234'" ],
    "parametersDescription" : [ "array", "start value", "accumulator expression", "result expression" ],
    "parametersToAutoComplete" : [ "array", "start_value", "accumulator_expression", "result_expression" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "any", "binaryfunction", "unaryfunction" ],
    "requiredParameters" : 4,
    "functionType" : "General"
  },
  "translate" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_translate,
    "returnType" : "string",
    "examples" : [ "translate('(bojjus)', '()', '[]')", "'[bojjus]'", "translate('(gunchus)', '()', '[')", "'[gunchus'" ],
    "parametersDescription" : [ "string to translate", "lookup characters", "replace characters" ],
    "parametersToAutoComplete" : [ "string_to_translate", "lookup_characters", "replace_characters" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string", "string" ],
    "requiredParameters" : 3,
    "functionType" : "General"
  },
  "multiply" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_multiply,
    "returnType" : "any",
    "examples" : [ "multiply(20, 10)", "200", "20 * 10", "200" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "isInsert" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isInsert,
    "returnType" : "boolean",
    "examples" : [ "isInsert()", "", "isInsert(1)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "denseRank" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_denseRank,
    "returnType" : "integer",
    "examples" : [ "denseRank()", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "Window"
  },
  "stddevPopulationIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_stddevPopulationIf,
    "returnType" : "double",
    "examples" : [ "stddevPopulationIf(region == 'West', sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "greaterOrEqual" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_greaterOrEqual,
    "returnType" : "boolean",
    "examples" : [ "greaterOrEqual(12, 12)", "true", "('dumbo' >= 'dum')", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "byOrigin" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_byOrigin,
    "returnType" : "any",
    "examples" : [ "toString(byOrigin('ancestor', 'ancestorStream'))", "" ],
    "parametersDescription" : [ "column name", "origin stream name" ],
    "parametersToAutoComplete" : [ "column_name", "origin_stream_name" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "byOrigins" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_byOrigins,
    "returnType" : "any",
    "examples" : [ "toString(byOrigins(['ancestor1', 'ancestor2'], 'ancestorStream'))", "" ],
    "parametersDescription" : [ "column names", "origin stream name" ],
    "parametersToAutoComplete" : [ "column_names", "origin_stream_name" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "byItem" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_byItem,
    "returnType" : "string",
    "examples" : [ "byItem( byName('customer'), 'orderItems') ? (itemName as string, itemQty as integer)", "", "byItem( byItem( byName('customer'), 'orderItems'), 'itemName') ? string", ""],
    "parametersDescription" : [ "parent column", "column name" ],
    "parametersToAutoComplete" : [ "parent column", "column name" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "byName" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_byName,
    "returnType" : "any",
    "examples" : [ "toString(byName('parent'))", "", "toLong(byName('income'))", "", "toBoolean(byName('foster'))", "", "toLong(byName($debtCol))", "", "toString(byName('Bogus Column'))", "", "toString(byName('Bogus Column', 'DeriveStream'))", "" ],
    "parametersDescription" : [ "column name", "stream name" ],
    "parametersToAutoComplete" : [ "column_name", "stream_name" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "byNames" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_byNames,
    "returnType" : "any",
    "examples" : [ "md5(byNames(['ID', 'State']))", "", "array(byNames(['column1', 'column3', 'column5']))", "" ],
    "parametersDescription" : [ "column names", "stream name" ],
    "parametersToAutoComplete" : [ "column_names", "stream_name" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "kurtosisIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_kurtosisIf,
    "returnType" : "double",
    "examples" : [ "kurtosisIf(region == 'West', sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "tanh" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_tanh,
    "returnType" : "double",
    "examples" : [ "tanh(0)", "0.0" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "first" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_first,
    "returnType" : "any",
    "examples" : [ "first(sales)", "", "first(sales, false)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "boolean" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "true" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_true,
    "returnType" : "boolean",
    "examples" : [ "(10 + 20 == 30)", "true", "(10 + 20 == 30)", "true()" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "lastDayOfMonth" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_lastDayOfMonth,
    "returnType" : "date",
    "examples" : [ "lastDayOfMonth(toDate('2009-01-12'))", "toDate('2009-01-31')" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "datetime" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "jaroWinkler" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_jaroWinkler,
    "returnType" : "double",
    "examples" : [ "jaroWinkler('frog', 'frog')", "1.0" ],
    "parametersDescription" : [ "from string", "to string" ],
    "parametersToAutoComplete" : [ "from_string", "to_string" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2
  },
  "toDouble" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toDouble,
    "returnType" : "double",
    "examples" : [ "toDouble(123.45)", "123.45", "toDouble('123.45')", "123.45", "toDouble('$123.45', '$###.00')", "123.45", "toDouble('�123,45', '�###,##', 'de')", "123.45" ],
    "parametersDescription" : [ "value", "format", "locale" ],
    "parametersToAutoComplete" : [ "value", "format", "locale" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "lesser" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_lesser,
    "returnType" : "boolean",
    "examples" : [ "lesser(12, 24)", "true", "('abcd' < 'abc')", "false", "(toTimestamp('2019-02-03 05:19:28.871', 'yyyy-MM-dd HH:mm:ss.SSS') < toTimestamp('2019-02-05 08:21:34.890', 'yyyy-MM-dd HH:mm:ss.SSS'))", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "lpad" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_lpad,
    "returnType" : "string",
    "examples" : [ "lpad('dumbo', 10, '-')", "'-----dumbo'", "lpad('dumbo', 4, '-')", "'dumb'", "lpad('dumbo', 8, '<>')", "'<><dumbo'" ],
    "parametersDescription" : [ "string to pad", "final padded length", "padding" ],
    "parametersToAutoComplete" : [ "string_to_pad", "final_padded_length", "padding" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "integral", "string" ],
    "requiredParameters" : 3,
    "functionType" : "General"
  },
  "toString" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toString,
    "returnType" : "string",
    "examples" : [ "toString(10)", "'10'", "toString('engineer')", "'engineer'", "toString(123456.789, '##,###.##')", "'123,456.79'", "toString(123.78, '000000.000')", "'000123.780'", "toString(12345, '##0.#####E0')", "'12.345E3'", "toString(toDate('2018-12-31'))", "'2018-12-31'", "isNull(toString(toDate('2018-12-31', 'MM/dd/yy')))", "true", "toString(4 == 20)", "'false'", "toString(toDate('12/31/18', 'MM/dd/yy', 'es-ES'), 'MM/dd/yy', 'de-DE')" ],
    "parametersDescription" : [ "value", "number format/date format", "timezone option", "date locale" ],
    "parametersToAutoComplete" : [ "value", "number_format_or_date_format", "timezone_option", "date_locale" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "string", "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "round" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_round,
    "returnType" : "double",
    "examples" : [ "round(100.123)", "100.0", "round(2.5, 0)", "3.0", "round(5.3999999999999995, 2, 7)", "5.40" ],
    "parametersDescription" : [ "number", "scale to round", "rounding option" ],
    "parametersToAutoComplete" : [ "number", "scale_to_round", "rounding_option" ],
    "synonyms" : [ ],
    "inputTypes" : [ "number", "number", "integral" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "length" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_length,
    "returnType" : "integer",
    "examples" : [ "length('dumbo')", "5" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "toDate" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toDate,
    "returnType" : "date",
    "examples" : [ "toDate('2012-8-18')", "toDate('2012-08-18')", "toDate('12/18/2012', 'MM/dd/yyyy', 'en-US')", "toDate('2012-12-18')" ],
    "parametersDescription" : [ "string", "date format", "locale" ],
    "parametersToAutoComplete" : [ "string", "date_format", "locale" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "isUpdate" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_isUpdate,
    "returnType" : "boolean",
    "examples" : [ "isUpdate()", "", "isUpdate(1)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "covariancePopulationIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_covariancePopulationIf,
    "returnType" : "double",
    "examples" : [ "covariancePopulationIf(region == 'West', sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number", "number" ],
    "requiredParameters" : 3,
    "functionType" : "Aggregate"
  },
  "regexExtract" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_regexExtract,
    "returnType" : "string",
    "examples" : [ "regexExtract('Cost is between 600 and 800 dollars', '(\\\\d+) and (\\\\d+)', 2)", "'800'", "regexExtract('Cost is between 600 and 800 dollars', `(\\d+) and (\\d+)`, 2)", "'800'" ],
    "parametersDescription" : [ "string", "regex to find", "match group 1-based index" ],
    "parametersToAutoComplete" : [ "string", "regex_to_find", "match_group_1-based_index" ],
    "synonyms" : [ "regex_extract" ],
    "inputTypes" : [ "string", "string", "integral" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "cosh" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_cosh,
    "returnType" : "double",
    "examples" : [ "cosh(0)", "1.0" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "typeMatch" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_typeMatch,
    "returnType" : "boolean",
    "examples" : [ "typeMatch(type, 'number')", "", "typeMatch('date', 'datetime')", "" ],
    "parametersDescription" : [ "type", "base type" ],
    "parametersToAutoComplete" : [ "type", "base_type" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "skewness" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_skewness,
    "returnType" : "double",
    "examples" : [ "skewness(sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "rpad" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_rpad,
    "returnType" : "string",
    "examples" : [ "rpad('dumbo', 10, '-')", "'dumbo-----'", "rpad('dumbo', 4, '-')", "'dumb'", "rpad('dumbo', 8, '<>')", "'dumbo<><'" ],
    "parametersDescription" : [ "string to pad", "final padded length", "padding" ],
    "parametersToAutoComplete" : [ "string_to_pad", "final_padded_length", "padding" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "integral", "string" ],
    "requiredParameters" : 3,
    "functionType" : "General"
  },
  "substring" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_substring,
    "returnType" : "string",
    "examples" : [ "substring('Cat in the hat', 5, 2)", "'in'", "substring('Cat in the hat', 5, 100)", "'in the hat'", "substring('Cat in the hat', 5)", "'in the hat'", "substring('Cat in the hat', 100, 100)", "''" ],
    "parametersDescription" : [ "string to subset", "from 1-based index", "number of characters" ],
    "parametersToAutoComplete" : [ "string_to_subset", "from_1-based_index", "number_of_characters" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "integral", "integral" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "substringIndex" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_substringIndex,
    "returnType" : "string",
    "examples" : [ "substringIndex('111-222-333', '-', 1)", "'111'", "substringIndex('111-222-333', '-', 2)", "'111-222'", "substringIndex('111-222-333', '-', -1)", "'333'", "substringIndex('111-222-333', '-', -2)", "'222-333'" ],
    "parametersDescription" : [ "string to subset", "delimiter", "count of delimiter occurences" ],
    "parametersToAutoComplete" : [ "string_to_subset", "delimiter", "count" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string", "integral" ],
    "requiredParameters" : 3,
    "functionType" : "General"
  },
  "regexReplace" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_regexReplace,
    "returnType" : "string",
    "examples" : [ "regexReplace('100 and 200', '(\\\\d+)', 'bojjus')", "'bojjus and bojjus'", "regexReplace('100 and 200', `(\\d+)`, 'gunchus')", "'gunchus and gunchus'" ],
    "parametersDescription" : [ "string", "regex to find", "substring to replace" ],
    "parametersToAutoComplete" : [ "string", "regex_to_find", "substring_to_replace" ],
    "synonyms" : [ "regex_replace" ],
    "inputTypes" : [ "string", "string", "string" ],
    "requiredParameters" : 3,
    "functionType" : "General"
  },
  "power" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_power,
    "returnType" : "double",
    "examples" : [ "power(10, 2)", "100" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number", "number" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "case" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_case,
    "returnType" : "any",
    "examples" : [ "case(10 + 20 == 30, 'dumbo', 'gumbo')", "'dumbo'", "case(10 + 20 == 25, 'bojjus', 'do' < 'go', 'gunchus')", "'gunchus'", "isNull(case(10 + 20 == 25, 'bojjus', 'do' > 'go', 'gunchus'))", "true", "case(10 + 20 == 25, 'bojjus', 'do' > 'go', 'gunchus', 'dumbo')", "'dumbo'" ],
    "parametersDescription" : [ "condition", "true_expression", "false_expression" ],
    "parametersToAutoComplete" : [ "condition", "true_expression", "false_expression" ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "any", "any" ],
    "requiredParameters" : 3,
    "functionType" : "General"
  },
  "toShort" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toShort,
    "returnType" : "short",
    "examples" : [ "toShort(123)", "123", "toShort('123')", "123", "toShort('$123', '$###')", "123" ],
    "parametersDescription" : [ "value", "format", "locale" ],
    "parametersToAutoComplete" : [ "value", "format", "locale" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "toByte" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_toByte,
    "returnType" : "byte",
    "examples" : [ "toByte(123)", "123", "toByte(0xFF)", "-1", "toByte('123')", "123"],
    "parametersDescription" : [ "value", "format", "locale" ],
    "parametersToAutoComplete" : [ "value", "format", "locale" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "sort" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_sort,
    "returnType" : "array",
    "examples" : [ "sort([4, 8, 2, 3], compare(#item1, #item2))", "[2, 3, 4, 8]", "sort(['a3', 'b2', 'c1'], iif(right(#item1, 1) >= right(#item2, 1), 1, -1))", "['c1', 'b2', 'a3']" ],
    "parametersDescription" : [ "array", "sort expression" ],
    "parametersToAutoComplete" : [ "array", "sort_expression" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "binaryfunction" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "type" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_type,
    "returnType" : "string",
    "examples" : [ "type(byPosition(1))", "", "type(byName($colName))", "", "type(custName)", "" ],
    "parametersDescription" : [ "column/expression" ],
    "parametersToAutoComplete" : [ "column_or_expression" ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1
  },
  "trim" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_trim,
    "returnType" : "string",
    "examples" : [ "trim('  dumbo  ')", "'dumbo'", "trim('!--!du!mbo!', '-!')", "'du!mbo'" ],
    "parametersDescription" : [ "string to trim", "trim characters" ],
    "parametersToAutoComplete" : [ "string_to_trim", "trim_characters" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "byPosition" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_byPosition,
    "returnType" : "any",
    "examples" : [ "toString(byPosition(1))", "", "toDecimal(byPosition(2), 10, 2)", "", "toBoolean(byName(4))", "", "toString(byName($colName))", "", "toString(byPosition(1234))", "" ],
    "parametersDescription" : [ "position" ],
    "parametersToAutoComplete" : [ "position" ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "hasPath" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_hasPath,
    "returnType" : "boolean",
    "examples" : [ "hasPath('grandpa.parent.child')", ""],
    "parametersDescription" : [ "column name", "stream name" ],
    "parametersToAutoComplete" : [ "column_name", "stream_name" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "byPath" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_byPath,
    "returnType" : "any",
    "examples" : [ "byPath('grandpa.parent.child')", "" ],
    "parametersDescription" : [ "column name", "stream name" ],
    "parametersToAutoComplete" : [ "column_name", "stream_name" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "tan" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_tan,
    "returnType" : "double",
    "examples" : [ "tan(0)", "0.0" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "abs" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_abs,
    "returnType" : "number",
    "examples" : [ "abs(-20)", "20", "abs(10)", "10" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "greater" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_greater,
    "returnType" : "boolean",
    "examples" : [ "greater(12, 24)", "false", "('dumbo' > 'dum')", "true", "(toTimestamp('2019-02-05 08:21:34.890', 'yyyy-MM-dd HH:mm:ss.SSS') > toTimestamp('2019-02-03 05:19:28.871', 'yyyy-MM-dd HH:mm:ss.SSS'))", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "sumIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_sumIf,
    "returnType" : "number",
    "examples" : [ "sumIf(state == 'CA' && commission < 10000, sales)", "", "sumIf(true, sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "contains" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_contains,
    "returnType" : "boolean",
    "examples" : [ "contains([1, 2, 3, 4], #item == 3)", "true", "contains([1, 2, 3, 4], #item > 5)", "false" ],
    "parametersDescription" : [ "array", "contains expression" ],
    "parametersToAutoComplete" : [ "array", "contains_expression" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "unaryfunction" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "keyValues" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_keyValues,
    "returnType" : "map",
    "examples" : [ "keyValues(['bojjus', 'appa'], ['gunchus', 'ammi'])", "['bojjus' -> 'gunchus', 'appa' -> 'ammi']", "keyValues(['bojjus'], ['gunchus'])['bojjus']", "'gunchus'" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "array" ],
    "requiredParameters" : 2
  },
  "varianceSample" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_varianceSample,
    "returnType" : "double",
    "examples" : [ "varianceSample(sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "sin" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_sin,
    "returnType" : "double",
    "examples" : [ "sin(2)", "0.9092974268256817" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "except" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_except,
    "returnType" : "array",
    "examples" : [ "except([10, 20, 30], [20, 40])", "[10, 30]", "except(['bojjus', 'gunchus', 'bojjus'], ['gunchus'])", "['bojjus']" ],
    "parametersDescription" : [ "first array", "second array" ],
    "parametersToAutoComplete" : [ "first_array", "second_array" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "array" ],
    "requiredParameters" : 2
  },
  "milliseconds" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_milliseconds,
    "returnType" : "long",
    "examples" : [ "milliseconds(2)", "2L" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "stddevSample" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_stddevSample,
    "returnType" : "double",
    "examples" : [ "stddevSample(sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "add" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_add,
    "returnType" : "any",
    "examples" : [ "add(10, 20)", "30", "10 + 20", "30", "add('ice', 'cream')", "'icecream'", "'ice' + 'cream' + ' cone'", "'icecream cone'", "add(toDate('2012-12-12'), 3)", "toDate('2012-12-15')", "toDate('2012-12-12') + 3", "toDate('2012-12-15')", "[10, 20] + [30, 40]", "[10, 20, 30, 40]", "toTimestamp('2019-02-03 05:19:28.871', 'yyyy-MM-dd HH:mm:ss.SSS') + (days(1) + hours(2) - seconds(10))", "toTimestamp('2019-02-04 07:19:18.871', 'yyyy-MM-dd HH:mm:ss.SSS')" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "varianceIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_varianceIf,
    "returnType" : "double",
    "examples" : [ "varianceIf(region == 'West', sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "skewnessIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_skewnessIf,
    "returnType" : "double",
    "examples" : [ "skewnessIf(region == 'West', sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "regexMatch" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_regexMatch,
    "returnType" : "boolean",
    "examples" : [ "regexMatch('200.50', '(\\\\d+).(\\\\d+)')", "true", "regexMatch('200.50', `(\\d+).(\\d+)`)", "true" ],
    "parametersDescription" : [ "string", "regex to match" ],
    "parametersToAutoComplete" : [ "string", "regex_to_match" ],
    "synonyms" : [ "regex_match" ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "reassociate" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_reassociate,
    "returnType" : "map",
    "examples" : [ "reassociate(['bojjus' -> 'gunchus', 'appa' -> 'ammi'], substring(#key, 1, 1) + substring(#value, 1, 1))", "['bojjus' -> 'bg', 'appa' -> 'aa']" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "map", "binaryfunction" ],
    "requiredParameters" : 2
  },
  "stddevSampleIf" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_stddevSampleIf,
    "returnType" : "double",
    "examples" : [ "stddevSampleIf(region == 'West', sales)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "number" ],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "compare" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_compare,
    "returnType" : "integer",
    "examples" : [ "(compare(12, 24) < 1)", "true", "(compare('dumbo', 'dum') > 0)", "true" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "like" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_like,
    "returnType" : "boolean",
    "examples" : [ "like('icecream', 'ice%')", "true" ],
    "parametersDescription" : [ "string", "pattern match" ],
    "parametersToAutoComplete" : [ "string", "pattern_match" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "sum" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_sum,
    "returnType" : "number",
    "examples" : [ "sum(col)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "log" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_log,
    "returnType" : "double",
    "examples" : [ "log(100, 10)", "2" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number", "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "and" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_and,
    "returnType" : "boolean",
    "examples" : [ "and(true, false)", "false", "true && false", "false" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "boolean", "boolean" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "currentDate" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_currentDate,
    "returnType" : "date",
    "examples" : [ "currentDate() == toDate('2250-12-31')", "false", "currentDate('PST')  == toDate('2250-12-31')", "false", "currentDate('America/New_York')  == toDate('2250-12-31')", "false" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 0,
    "functionType" : "General"
  },
  "locate" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_locate,
    "returnType" : "integer",
    "examples" : [ "locate('mbo', 'dumbo')", "3", "locate('o', 'microsoft', 6)", "7", "locate('bad', 'good')", "0" ],
    "parametersDescription" : [ "substring to find", "string", "from index - 1-based" ],
    "parametersToAutoComplete" : [ "substring_to_find", "string", "from_index_-_1-based" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "string", "integral" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "originColumns" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_originColumns,
    "returnType" : "any",
    "examples" : [ "columns()", "", "columns('DeriveStream')", "" ],
    "parametersDescription" : [ "stream name" ],
    "parametersToAutoComplete" : [ "stream_name" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string" ],
    "requiredParameters" : 1
  },
  "right" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_right,
    "returnType" : "string",
    "examples" : [ "right('bojjus', 2)", "'us'", "right('bojjus', 20)", "'bojjus'" ],
    "parametersDescription" : [ "string to subset", "number of characters" ],
    "parametersToAutoComplete" : [ "string_to_subset", "number_of_characters" ],
    "synonyms" : [ ],
    "inputTypes" : [ "string", "integral" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "acos" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_acos,
    "returnType" : "double",
    "examples" : [ "acos(1)", "0.0" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "cumeDist" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_cumeDist,
    "returnType" : "integer",
    "examples" : [ "cumeDist()", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "Window"
  },
  "days" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_days,
    "returnType" : "long",
    "examples" : [ "days(2)", "172800000L" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "integer" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "month" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_month,
    "returnType" : "integer",
    "examples" : [ "month(toDate('2012-8-8'))", "8" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "datetime" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "notEquals" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_notEquals,
    "returnType" : "boolean",
    "examples" : [ "12 != 24", "true", "'bojjus' != 'bo' + 'jjus'", "false" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "any" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  },
  "collect" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_collect,
    "returnType" : "array",
    "examples" : [ "collect(salesPerson)", "", "collect(firstName + lastName))", "", "collect(@(name = salesPerson, sales = salesAmount) )", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "collectUnique" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_collect,
    "returnType" : "array",
    "examples" : [ "collectUnique(salesPerson)", "", "collectUnique(firstName + lastName))", "", "collectUnique(@(name = salesPerson, sales = salesAmount) )", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "Aggregate"
  },
  "approxPercentile" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_approxPercentile,
    "returnType" : "array",
    "examples" : [ "approxPercentile(custId, [0.25, 0.5])", "", "approxPercentile(custId, [0.25], 20000)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "array", "number"],
    "requiredParameters" : 2,
    "functionType" : "Aggregate"
  },
  "topN" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_topN,
    "returnType" : "array",
    "examples" : [ "topN(productId, num_sales, 10)", "", "topN(custId, count, 10)", "", "topN(custId, count, 5)", ""],
    "parametersDescription" : [ "column/expression", "count", "n"],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any", "long", "integer"],
    "requiredParameters" : 3,
    "functionType" : "Aggregate"
  },
  "random" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_random,
    "returnType" : "long",
    "examples" : [ "random(1)", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : ["seed"],
    "synonyms" : [ ],
    "inputTypes" : [ "number" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "size" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_size,
    "returnType" : "integer",
    "examples" : [ "size(['bojjus', 'gunchus'])", "2", "size(['bojus' -> 'guhus', 'appa' -> 'ammi'])", "2" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : ["array"],
    "synonyms" : [ ],
    "inputTypes" : [ "array" ],
    "requiredParameters" : 1,
    "functionType" : "General"
  },
  "lookup" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_lookup,
    "returnType" : "complex",
    "examples" : [ "cacheSink1#lookup(key1,key2)", "", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "Transformation"
  },
  "mlookup" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_mlookup,
    "returnType" : "complex",
    "examples" : [ "cacheSink1#mlookup(key1,key2)", "", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ "any" ],
    "requiredParameters" : 1,
    "functionType" : "Transformation"
  },
  "outputs" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_outputs,
    "returnType" : "array",
    "examples" : [ "cacheSink1#outputs()", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "Transformation"
  },
  "output" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_output,
    "returnType" : "complex",
    "examples" : [ "cacheSink1#output()", "" ],
    "parametersDescription" : [ ],
    "parametersToAutoComplete" : [ ],
    "synonyms" : [ ],
    "inputTypes" : [ ],
    "requiredParameters" : 0,
    "functionType" : "Transformation"
  },
  "find" : {
    "description" : dataFlowFunctionDescriptions.DataFlowFunctionDescription_find,
    "returnType" : "any",
    "examples" : [ "find([10, 20, 30], #item > 10)", "20", "find(['bojjus', 'gunchus', 'ammi'], length(#item) > 4)", "'bojjus'"],
    "parametersDescription" : [ "array", "find expression" ],
    "parametersToAutoComplete" : [ "array", "find_expression" ],
    "synonyms" : [ ],
    "inputTypes" : [ "array", "unaryfunction" ],
    "requiredParameters" : 2,
    "functionType" : "General"
  }
}
